@if (formControl()) {
<div class="autocomplete form-group">
  <mat-form-field class="form-field">
    <input matInput [readonly]="meta().readonly" [placeholder]="meta().name" class="form-control input-date" [formControl]="formControl()!" [matAutocomplete]="auto" >
    <mat-autocomplete #auto="matAutocomplete" (optionSelected)="onPick($event)">
      @for (item of filtered | async; track item._id) {
        <mat-option [value]="item">
          {{item.name}}
        </mat-option>
      }
    </mat-autocomplete>
    <mat-hint><strong>{{meta().info}}</strong></mat-hint>
    @if (formControl()?.hasError('required')) {
      <mat-error>
        {{meta().name}} is <strong>required</strong>
      </mat-error>
    }
    @if (formControl()?.hasError('form')) {
      <mat-error>
        {{formError}}
      </mat-error>
    }
  </mat-form-field>
</div>
}
